// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import type { State } from 'store';
import { BaseActions, UserActions } from 'store/actionCreators';
import storage, { keys } from 'lib/storage';
import { resetSession } from 'lib/tracking';
import UserMobileMenu from 'components/base/UserMobileMenu';
import type { UserData } from 'store/modules/user';

type Props = {
  userMobileMenu: boolean,
  user: ?UserData,
  depositHistoryCount: number,
};

class UserMobileMenuContainer extends Component<Props> {
  onLogout = async () => {
    // SSO 로그아웃 비활성화 - 기존 로그아웃 방식 사용

    // Tawk 로그아웃
    if (window.Tawk_API) {
      window.Tawk_API.logout();
    }

    // 추적 세션 리셋
    resetSession();

    // 로컬 스토리지 정리
    storage.remove(keys.user);

    // 백엔드 로그아웃 API 호출
    try {
      await UserActions.logout();
    } catch (e) {
      console.warn('Backend logout failed:', e);
    }

    // 홈페이지로 리다이렉트
    window.location.href = '/';
  };

  onClickOutside = () => {
    BaseActions.hideMobileUserMenu();
    document.body.style.overflowY = '';
  };

  render() {
    const { userMobileMenu, user, location, depositHistoryCount } = this.props;
    const { onClickOutside, onLogout } = this;

    return (
      <UserMobileMenu
        logged={!!user}
        onLogout={onLogout}
        onClickOutside={onClickOutside}
        rule={user && user.rule}
        displayName={user && user.displayName}
        username={user && user.username}
        thumbnail={user && user.thumbnail}
        showMobileUserMenu={userMobileMenu}
        hasDepositHistory={depositHistoryCount > 0}
        eventTypes={['click', 'touchend']}
        location={location}
      />
    );
  }
}

export default connect(
  ({ base, user, deposit }: State) => ({
    userMobileMenu: base.userMobileMenu,
    user: user.user,
    depositHistoryCount: deposit.historyCount || 0,
  }),
  () => ({}),
)(UserMobileMenuContainer);



// WEBPACK FOOTER //
// ./src/containers/base/UserMobileMenuContainer.js